import * as v from 'valibot';

import {
  type Entities,
  type Filters,
  type FiltersUpdateApi,
  type Option,
  optionSchema,
  paginatedSchema,
} from './_core.model';

export const customerApiSchema = v.object({
  id: v.number(),
  name: v.string(),
});

export const customerSchema = v.object({
  ...customerApiSchema.entries,
  ...optionSchema.entries,
});

export const customersApiSchema = paginatedSchema(customerApiSchema);

export type CustomerApi = v.InferOutput<typeof customerApiSchema>;
export type CustomersApi = v.InferOutput<typeof customersApiSchema>;

export type CustomerFilters = Filters<CustomerApi>;

export type CustomerFiltersUpdateApi = FiltersUpdateApi<CustomerApi>;

export type Customer = Prettify<Option<v.InferOutput<typeof customerSchema>>>;

export type Customers = Entities<Customer>;
